import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import { CloseButton, Modal } from "react-bootstrap";
import { ValidatorForm } from "react-form-validator-core";

import { updateCustomer, updateGenerateCardData } from "../../../services/auth";
import TextValidator from "../../partial/TextValidator";
import { connect } from "react-redux";
import { clearCustomer, getCustomer } from "../../../actions/customer";

const CardUpdateModal = ({ Customer, getCustomer, clearCustomer, customer_Code, fetchCustomerDetail, show, close }) => {
  const [loader, setLoader] = useState(false);
  const [cardNum, setCardNum] = useState();

  const fetchCustomerList = async () => {
    setLoader(true);
    await clearCustomer();
    const token = JSON.parse(localStorage.getItem("token_gen"));
    let id = localStorage.getItem("Id");
    await getCustomer(token?.access_token, id, 0, 50, " ");
    setTimeout(() => {
      setLoader(false);
    }, 1000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const cardNumExist = Customer?.data?.data?.data?.find((ele) => ele.customerData?.memberCardNumber === cardNum)
    if (cardNumExist) {
      swal({
        position: "center",
        icon: "error",
        title: "Membership Card Number alreday exists",
        showConfirmButton: false,
        timer: 5000,
      });
      return
    }

    let response;
    try {
      let token = JSON.parse(localStorage.getItem("token_gen"));
      setLoader(true);
      const res = await updateCustomer(
        token?.access_token,
        customer_Code,
        { memberCardNumber: cardNum }
      );
      if (res.message === "Request processed successfully.") {
        response = await updateGenerateCardData(token?.access_token, cardNum, {
          status: true,
        });
        if (response.message === "Card data updated successfully.") {
          await fetchCustomerDetail();
          await fetchCustomerList()
          swal({
            position: "center",
            icon: "success",
            title: response.message,
            showConfirmButton: false,
            timer: 5000,
          });
        } else {
          swal({
            title: " Oops!",
            text: response.message,
            icon: "error",
            button: "oh no!",
            timer: 5000,
          });
        }
      }
    } catch (error) {
      swal({
        title: " Oops!",
        text: response.message,
        icon: "error",
        button: "oh no!",
        timer: 5000,
      });
    } finally {
      setLoader(false);
      close();
    }
  };

  return (
    <>
      {loader && (
        <div className="mainPreloaderMain">
          <div className="mainPreloader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}
      <Modal show={show} onHide={close} size="lg" centered>
        <Modal.Header>
          <Modal.Title style={{ fontSize: "16px", fontWeight: 600 }}>
            Membership Card Number
          </Modal.Title>
          <CloseButton onClick={close} variant="black" />
        </Modal.Header>
        <Modal.Body
          className="dashboard__transactionsModal"
          style={{ position: "relative", minHeight: "85px" }}
        >
          <ValidatorForm
            className="signUpPage__formSection"
            onSubmit={handleSubmit}
          >
            <div className="modal-body">
              <div className="form-group">
                <TextValidator
                  onChange={(e) => setCardNum(e.target.value)}
                  value={cardNum}
                  placeholder="Enter membership card number"
                  name="count"
                  className="form-control"
                  validators={["required", "matchRegexp:^(?!0)\\w+$",]}
                  errorMessages={["This field is required", "Please enter a valid membership card number"]}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button type="submit" className="btn btn-primary">
                Submit
              </button>
            </div>
          </ValidatorForm>
        </Modal.Body>
      </Modal >
    </>
  );
};
const mapStateToProps = (state) => ({
  Customer: state.Customer,
});

const mapDispatchToProps = {
  getCustomer,
  clearCustomer,
};

export default connect(mapStateToProps, mapDispatchToProps)(CardUpdateModal);
